<div class="row" style="margin-bottom:10px" id="attachments_inline">
    <div class="col-md-12">
        <div class="panel panel-default" *ngIf="meta | async as m">
            <div class="panel-heading" (click)="getItems()">
                <h4 class="panel-title">
                    <a role="button">
                        <span *ngIf="loading"><i class="fa fa-spinner fa-pulse"></i></span>
                       <i *ngIf="!attachmentsLoaded && !loading" class="pull-left fa fa-chevron-down"></i>
                        <i *ngIf="attachmentsLoaded && attachIsCollapsed && !loading && attachments.length !== 0"
                           class="pull-left fa fa-chevron-down"></i>
                        <i *ngIf="attachmentsLoaded && !attachIsCollapsed && attachments.length > 0" class="pull-left fa fa-chevron-up"></i>
                        <span *ngIf="attachmentsLoaded && attachments.length === 0">No </span> {{ m.verbose_name_plural }}
                    </a>
                    <div *ngIf="m.permissions.write && disableEditing !== true" class="pull-right" style="position: sticky; right: 0;">
                                <span style="cursor: pointer;" (click)="open($event)">Add {{ m.verbose_name }}
                                    <i class="fa fa-plus-circle"></i></span>
                    </div>
                </h4>
            </div>
            <div class="panel-body" *ngIf="attachmentsLoaded && attachments.length > 0 && !loading"
                 [ngbCollapse]="attachIsCollapsed">
              <div  style="display: flex; flex-wrap: wrap; flex: 1;">
                <div *ngFor="let attachment of attachments" class="text-center" style="margin-right: 15px; position: relative;">
                    <a *ngIf="(attachment.filetype | isImage)"
                       (click)="viewImage(attachment)" class="thumbnail">
                        <img style="max-height:350px; margin-top: 3px;" *ngIf="(attachment.filetype | isImage)"
                             [src]="'data:'+attachment.filetype+';base64,'+attachment.base64"/>
<!--                        <img style="max-width: 218px;" src="assets/very-basic-file-icon.png" *ngIf="attachment.filetype === 'application/pdf'"/>-->
                        {{ attachment.filename }}
                    </a>

                    <a *ngIf="!(attachment.filetype | isImage)"
                       [href]="getDownloadUrl(attachment)" class="thumbnail" target="_blank">
                        <img style="max-width: 218px;" src="/assets/very-basic-file-icon.png"/>
                        {{ attachment.filename }}
                    </a>
                    <button *ngIf="m.permissions.write && disableEditing !== true" class="btn btn-circle"
                            style="position: absolute; top: 15px; right:17px; width: 22px; height: 22px; padding:0; background-color: white;" ngbTooltip="Delete?" placement="bottom" container="body">
                        <i (click)="delete(attachment)"
                           class="fa fa-times-circle-o fa-2x" style="position: absolute; top: -1px; right: 0.75px;">
                        </i>
                    </button>

                </div>
              </div>
<!--                <div ng-repeat-end *ngIf="($index+1) % 3 == 0 && $index !== 0"-->
<!--                     class="clearfix visible-lg-block visible-md-block visible-sm-block visible-xs-block"></div>-->
            </div>

        </div>
    </div>
</div>
